import { useEffect, useState } from "react";
import axios from "axios";
import { COURSES_LIST } from "@/lib/data";
import { mediaSrc } from "@/lib/media";

let cached = null;

/** Static course list merged with live DB values (cover photo, title, short). */
export function useCourses() {
  const [live, setLive] = useState(cached);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/courses`)
      .then((r) => {
        cached = r.data;
        setLive(r.data);
      })
      .catch(() => {});
  }, []);

  const bySlug = new Map((live || []).map((c) => [c.slug, c]));
  return COURSES_LIST.map((c) => {
    const db = bySlug.get(c.slug);
    return db
      ? { ...c, title: db.title || c.title, short: db.short || c.short, cover: mediaSrc(db.cover) || c.cover }
      : c;
  });
}
